<template>
  <div class="communicationList-component">
    <div class="search-div">
      <v-text-field
        filled
        rounded
        dense
        no-resize
        single-line
        v-model="searchText"
        color="#6f767a4d"
        class="search-text bottom-margin"
        append-icon="fa-magnifying-glass"
        :label="$t('Communications.searchTxt')"
        height="40px"
      ></v-text-field>
      <v-btn class="generic-button" @click="search">{{
        $t("Communications.search")
      }}</v-btn>
      <!-- <v-btn class="generic-button back" @click="back">{{
        $t("Misc.back")
      }}</v-btn> -->
    </div>
    <div class="bu">{{ $t("Communications.bu") }}</div>
    <div class="custom-select bottom-margin">
      <v-select
        v-model="division"
        :items="divisions"
        item-text="descrizione"
        item-value="id"
        solo
        @change="divisionChanged"
      >
        <template v-slot:item="{ item }">
          <span class="custom-select-item">
            {{ item.descrizione }}
          </span>
        </template>
      </v-select>
    </div>
    <div>
      <communication-table
        :items="communications"
        :fromHistory="true"
      ></communication-table>
    </div>
  </div>
</template>
<style>
.communicationList-component .search-div {
  margin-top: 42px;
}

.communicationList-component .search-div .search-text {
  display: inline-block;
  margin-right: 21px;
}

.communicationList-component .search-div .generic-button.back {
  float: right;
}

.communicationList-component .bu {
  margin-top: 10px;
  margin-bottom: 10px;
  font: normal normal bold 20px Lato;
}

/* todo */
.communicationList-component .v-list-item .v-list-item__title,
.communicationList-component .v-list-item .v-list-item__subtitle {
  color: #6f767a;
  font: normal normal bold 20px Lato !important;
}

/* todo */
.communicationList-component .theme--light.v-list {
  background-color: #c6c6c6;
}

.communicationList-component .bottom-margin {
  margin-bottom: 40px;
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";

export default {
  components: {},

  props: {},
  data() {
    return {
      isMobile: false,
      searchText: "",
      division: null,
      divisions: [],
      communications: [],
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    MyFercamApi.GetDivisions().then((res) => {
      //   console.log("res", res.data);
      this.divisions = res.data;
      this.division = this.divisions[0];

      this.search();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    search() {
      var filter = {
        searchText: this.searchText,
        divisionId: this.division.id ? this.division.id : this.division,
      };
      //   console.log("filter", filter);
      MyFercamApi.GetCommunicationsFiltered(filter).then((res) => {
        // console.log("filtered", res.data);
        this.communications = res.data;
      });
    },
    divisionChanged() {
      this.search();
    },

    back() {
      router.push({ name: "admin" }).catch((err) => {
        this.close();
      });
    },
  },
};
</script>